/**
 * Program: Mixin for Multilingual Processing
 * Author: SDL
 * Description: Mixin for Multilingual Processing
 */
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters({
            locale: 'getLocale',
        }),
    },
    methods: {
        getLabel({ enLabel, koLabel, label, localeLabel }) {
            switch (this.locale) {
                case 'en_US':
                    return enLabel;
                case 'ko_KR':
                    return koLabel;
                case 'zh_CN':
                    return label;
                default:
                    return localeLabel;
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixin/SDLLocale.js